(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ito_ui_icons_react"] = factory(require("react"));
	else
		root["ito_ui_icons_react"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__155__) => {
return 